/* Maison du Booster : extrait de snippets/mdb-ux-tokens.liquid (23/09, charge en defer) */
  (function () {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var MDB = window.MDB = window.MDB || {};
    /* retour haptique (Android ; ignore ailleurs), jamais si l'utilisateur limite les animations */
    MDB.vibrer = function (motif) { try { if (!reduit && navigator.vibrate) navigator.vibrate(motif || 12); } catch (e) {} };
    var ICONES = {
      succes: '<svg class="mdb-toast__icone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.2 4.2L19 7"/></svg>',
      erreur: '<svg class="mdb-toast__icone" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7.5v5.5M12 16.5v.5"/></svg>',
      info: ''
    };
    function conteneur() {
      var c = document.querySelector('.mdb-toasts');
      if (!c) {
        c = document.createElement('div');
        c.className = 'mdb-toasts';
        c.setAttribute('role', 'status');
        c.setAttribute('aria-live', 'polite');
        document.body.appendChild(c);
      }
      return c;
    }
    /* MDB.toast('Texte', { type: 'succes'|'erreur'|'info', action: { libelle: 'Annuler', fn: function(){} }, duree: 4000 }) */
    MDB.toast = function (texte, o) {
      o = o || {};
      var t = document.createElement('div');
      t.className = 'mdb-toast mdb-toast--' + (o.type || 'info');
      t.innerHTML = (ICONES[o.type] || '') + '<span class="mdb-toast__texte"></span>';
      t.querySelector('.mdb-toast__texte').textContent = texte;
      var fini = false;
      function fermer() {
        if (fini) return; fini = true;
        t.classList.add('is-sortie');
        setTimeout(function () { t.remove(); }, 220);
      }
      if (o.action) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mdb-toast__action'; b.textContent = o.action.libelle;
        b.addEventListener('click', function () { fermer(); o.action.fn(); });
        t.appendChild(b);
      }
      conteneur().appendChild(t);
      setTimeout(fermer, o.duree || (o.action ? 6000 : 3500));
      return { fermer: fermer };
    };
  })();
